export enum RefundReason {
  // Internal refund reasons
  AMBASSADOR_ERROR = "ambassador_error",
  BREEDER_ERROR = "breeder_error",
  DS_ERROR = "ds_error",
  DPD_INCORRECT_ADDRESS = "dpd_incorrect address",
  DPD_STOLEN_BOX = "dpd_stolen box",
  DPD_DAMAGED_DEPOT = "dpd_damaged depot",
  DPD_DAMAGED_DELIVERY = "dpd_damaged delivery",
  DPD_DELAYED_DELIVERY = "dpd_delayed delivery",
  QUALITY_INVESTIGATING = "quality_investigating",
  QUALITY_OPEN_PACKAGING = "quality_open packaging",
  QUALITY_DEFROSTED = "quality_defrosted",
  QUALITY_EMPTY = "quality_empty",
  QUALITY_FOREIGN_OBJECT = "quality_foreign object",
  QUALITY_ICE_PACK = "quality_ice pack",
  QUALITY_BROKEN = "quality_broken",
  QUALITY_SMELL = "quality_smell",
  ERROR_CX = "error_cx",
  ERROR_CP = "error_cp",
  ERROR_TECH = "error_tech",
  ERROR_COMMS = "error_comms",
  ERROR_P_AND_P = "error_p&p",
  MARKETING_RESEARCH = "marketing_research",
  TEAM_DISCOUNT = "team_discount",
  LITTER_RETURN = "litter_return",
  GWG_CAT_PASSED_AWAY = "GWG_cat passed_away",
  GWG_CAT_HEALTH = "GWG_cat health",
  GWG_REVIEW = "GWG_review",
  GWG_WAIVED_DELIVERY_FEE = "GWG_waived_delivery_fee",
  GWG_UNAWARE_FROZEN = "GWG_unaware_frozen",
  GWG_VULNERABLE_ERROR_LTV_CP = "GWG_vulnerable_error_LTV_CP",
  ORDER_CANCELLED_PRE_CUT_OFF = "Order cancelled pre cut-off",
  REVIEW_PREVENTION = "review_prevention",
  TESTING_TEAM = "Testing_Team",
}
